import { render, staticRenderFns } from "./EditProfileDescktop.vue?vue&type=template&id=02d9a888&"
import script from "./EditProfileDescktop.vue?vue&type=script&lang=js&"
export * from "./EditProfileDescktop.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileDescktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports